import React from 'react';
import ConnectionMenu from '../../../TaskNode/ConnectionMenu';

/**
 * Menu opened from a (+) handle: insert before, or add a connected node after.
 */
export default function LayerConnectionMenu({
  taskId,
  position,
  mode,
  branch,
  tasks,
  isMultiCampaignMode,
  checkClipboard,
  onCreateCampaign,
  onCreateConnectedNode,
  onInsertMissionBefore,
  onPasteBeforeHost,
  onClose,
  menuRef,
}) {
  const menuTask = taskId ? tasks.find((task) => task.id === taskId) : null;
  const open = Boolean(taskId && position);

  return (
    <ConnectionMenu
      menuRef={menuRef}
      open={open}
      position={position || { x: 0, y: 0 }}
      preferAbove={mode === 'before'}
      title={mode === 'before' ? 'Insert Before' : 'Add Connected Node'}
      onSelect={(nodeType) => {
        if (mode === 'before') {
          if (nodeType === 'paste') onPasteBeforeHost?.(taskId);
          else onInsertMissionBefore?.(taskId, nodeType);
        } else {
          onCreateConnectedNode?.(taskId, nodeType, branch);
        }
        onClose();
      }}
      onClose={onClose}
      isMultiCampaignMode={isMultiCampaignMode}
      sourceCampaign={menuTask?.sourceCampaign}
      checkClipboard={checkClipboard}
      onCreateCampaign={typeof onCreateCampaign === 'function'
        ? () => onCreateCampaign({ sourceTaskId: taskId, branch, mode })
        : undefined}
    />
  );
}
